import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

const API_URL = process.env.REACT_APP_API_URL;

const PacksForTrustComponent = ({ trust, product, clickHandler }) => {
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        setDataLoading(true);
        const params = new URLSearchParams({
          trust: trust.hospital_trust,
          product: product
        });
        const res = await fetch(
          `${API_URL}/api/get_prescriptions_for_trust?${params}`
        );
        const d = await res.json();
        if (isMounted) {
          setData(d);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setDataLoading(false);
      }
    })();

    return () => { isMounted = false; };
  }, [trust]);

  return (
    <div 
      style={{
        position:"absolute",
        top:"50%", left:"50%",
        transform:"translate(-50%, -50%)",
        background:"#fff",
        borderRadius:"8px",
        width:"90%",
        maxHeight:"500px",
        padding:"18px",
        boxShadow:"0 8px 30px rgba(0,0,0,0.25)",
        zIndex:5000,
        display:"flex",
        flexDirection:"column"
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
          borderBottom:"1px solid #eee",
          paddingBottom:"12px",
          marginBottom:"12px"
        }}
      >
        <div style={{ fontSize:"18px", fontWeight:600 }}>
          {trust.hospital_trust} — Outpatient Prescribing
        </div>

        <button
          onClick={clickHandler}
          style={{
            border:"none",
            background:"transparent",
            fontSize:"20px",
            fontWeight:"bold",
            cursor:"pointer",
          }}
        >
          ✕
        </button>
      </div>


      {/* BAR CHART */}
      {data && data.length > 0 && (
        <div style={{ width:"100%", height:"350px" }}>
          <ResponsiveContainer>
            <BarChart
              data={data}
              margin={{ top: 10, right: 10, bottom: 30, left: 0 }}
            >
              <CartesianGrid stroke="#e0e0e0" strokeDasharray="3 3" />

              <XAxis
                dataKey="period"
                tick={{ fontSize:12 }}
                interval={0}
              />

              <YAxis
                tick={{ fontSize:12 }}
                label={{ value:"Packs", angle:-90, position:"insideLeft", offset: 10 }}
              />

              {/* <Tooltip /> */}

              <Bar
                dataKey="packs"
                name="Packs prescribed"
                fill="#00BFA5"
                radius={[6, 6, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* STATES */}
      {(!data || data.length === 0) && !dataLoading && (
        <div style={{ padding:"20px", textAlign:"center" }}>
          No data for this trust
        </div>
      )}

      {dataLoading && (
        <div style={{ padding:"20px", textAlign:"center" }}>
          Loading…
        </div>
      )}
    </div>
  );
};

export default PacksForTrustComponent;
